<script setup lang="ts">
import { ref } from 'vue';

const emit = defineEmits<{
	close: [password: string | false];
}>();

const password = ref('');

function handleSubmit() {
	emit('close', password.value);
}

function handleCancel() {
	emit('close', false);
}
</script>

<template>
	<DDialog
		:title="$t('file_preview.pdf.file_unlock')"
		:description="$t('file_preview.pdf.file_unlock_prompt')"
		:cancel="{
			onClick: handleCancel,
		}"
		:confirm="{
			onClick: handleSubmit,
			label: $t('file_preview.pdf.unlock'),
			type: 'submit',
			form: 'passwordForm',
		}"
	>
		<template #body>
			<form id="passwordForm" @submit.prevent="handleSubmit">
				<DInputPassword v-model="password" autofocus block />
			</form>
		</template>
	</DDialog>
</template>
